export const calendar = () => (
  <path
    d="M16 1v4M8 1v4M3 9h18M5 3h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
